export default "__VITE_ASSET__C0n_sv3k__"